import { Button as AntdButton } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;

  > img {
    align-self: center;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 4px;
`;

export const StockTransferTitle = styled.h1`
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
`;

export const FinishButton = styled(AntdButton)`
  width: 100%;
  max-width: 160px;
  height: 44px;
  border-radius: 4px;
  font-family: ProximaNovaRg;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  cursor: pointer;
  align-self: center;
`;

export const StockListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 16px;
  border: 1px solid #EDEDED;
  border-radius: 4px;
  padding: 16px;

  max-height: calc(100vh - 490px);
  overflow-y: auto;
`;

export const StockItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  width: 100%;
  gap: 10px;
`;

export const StockName = styled.h3`
  font-size: 14px;
  line-height: 19px;
  font-weight: 700;
  margin: 0;
  flex: 1;
`;

export const StockLot = styled.p`
  font-size: 13px;
  line-height: 18px;
  font-weight: 700;
  margin: 0;
`;
